import React from 'react'
import * as Components from '../components/members'

function MembersPage() {
  return <Components.MembersTable />
}
export default MembersPage
